import OtherDirectories from './OtherDirectories'

export default OtherDirectories
